// Assets/shop-all.js
// Mamourse Shop All Page - EXACT Product Filtering with Live Shopify Sync

const allProducts = [
  { id: 1, title: "Babybear Bag", handle: "babybear-bag", isTopSeller: true, variants: [{ name: "Red", id: "50216386953497", price: 49.95, comparePrice: 79.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-1.jpg?v=1777061004" }, { name: "Black", id: "50216387051801", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Black8.jpg?v=1777061004" }, { name: "Blue", id: "50216387019033", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-3.jpg?v=1777061004" }, { name: "Grey", id: "50216386986265", price: 49.95, comparePrice: 79.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse-2.jpg?v=1777061004" }] },
  { id: 2, title: "CozyCub Baby Sleeping Bag", handle: "cozycub-baby-sleeping-bag", isTopSeller: true, variants: [{ name: "Pink 0-3M", id: "47437268680985", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" }, { name: "Pink 3-6M", id: "50190157676825", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" }, { name: "Pink 6-9M", id: "50190157709593", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725726562_76e4d525-8ba5-4824-ba88-c1468dbe74ef.png?v=1777059720" }, { name: "Blue 0-3M", id: "47437268648217", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" }, { name: "Blue 3-6M", id: "50190157742361", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" }, { name: "Blue 6-9M", id: "50190157775129", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725722396_cb21fb37-eef8-42e9-99fa-6171aba0b61b.png?v=1777059718" }, { name: "White 0-3M", id: "47437268058393", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" }, { name: "White 3-6M", id: "50190157807897", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" }, { name: "White 6-9M", id: "50190157840665", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1700725717037_14b1f923-b49b-4729-bbb9-50a56bc8e919.png?v=1777059718" }] },
  { id: 3, title: "Carrybear Bag", handle: "carrybear-bag", isTopSeller: true, variants: [{ name: "White", id: "49507609739545", price: 199.95, comparePrice: 249.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20240816_202224-removebg-preview.png?v=1744515289" }, { name: "Pink", id: "45336597004569", price: 199.95, comparePrice: 249.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/0H3A0011-2.jpg?v=1777062659" }, { name: "Blue", id: "45336586584345", price: 199.95, comparePrice: 249.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20230714-WA0003_1.jpg?v=1744515289" }] },
  { id: 4, title: "Butterfly Comfort Nursing Pillow", handle: "butterfly-comfort-nursing-pillow", isTopSeller: true, variants: [{ name: "Pink", id: "50216413757721", price: 34.95, comparePrice: 49.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/51gqicJn-0L.-AC_SL1500.jpg?v=1722639414" }, { name: "Grey", id: "50216413790489", price: 34.95, comparePrice: 49.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_6f0a4b72-93f1-447a-9f4d-378f80bc4fa4.png?v=1712627607" }] },
  { id: 5, title: "Pandallow", handle: "pandallow", isTopSeller: true, variants: [{ name: "ZigZag", id: "50165296365849", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0046.jpg?v=1777063574" }, { name: "Blue ZigZag", id: "52012817023257", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_959b261f-1b60-41b6-8e30-ce8f6008ca5a.png?v=1777063964" }, { name: "Night Sky", id: "50165296398617", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0047.jpg?v=1777063594" }, { name: "Pink Stars", id: "50165296431385", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0048.jpg?v=1777063614" }, { name: "Grey Stars", id: "50165296464153", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0049.jpg?v=1777063632" }, { name: "White Stars", id: "50165296496921", price: 14.97, comparePrice: 29.99, inStock: false, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0051.jpg?v=1777063691" }, { name: "Crown", id: "50165296529689", price: 14.97, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20250201-WA0050.jpg?v=1777063667" }] },
  { id: 6, title: "Cuddle Pouch Hoodie", handle: "cuddle-pouch-hoodie", isTopSeller: true, variants: [{ name: "Red-2XL", id: "47999663505689", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9406e812-e15e-49b1-86af-214c028fd927.png?v=1708434223" }, { name: "Light Purple-M", id: "47978792419609", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" }, { name: "Light Purple-2XL", id: "47999663538457", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightpurple.png?v=1708110990" }, { name: "Purple-XL", id: "47999655969049", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/purple.png?v=1708434223" }, { name: "Light Grey-M", id: "47978792681753", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" }, { name: "Light Grey-2XL", id: "47999663603993", price: 19.95, comparePrice: 44.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/lightgrey.png?v=1708434223" }] },
  { id: 7, title: "CubCloud Head Shaping Pillow", handle: "cubcloud-head-shaping-pillow", isTopSeller: true, variants: [{ name: "Yellow", id: "51446935060761", price: 9.98, comparePrice: 14.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/yellow.jpg?v=1759351337" }] },
  { id: 8, title: "Zein Educational Toy", handle: "zein", isTopSeller: false, variants: [{ name: "Standard", id: "52288206995737", price: 17.97, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_d99c426e-4d8e-414b-8037-753985caafd2.png?v=1746732508" }] },
  { id: 9, title: "Abjad", handle: "abjad", isTopSeller: false, variants: [{ name: "Brown", id: "52288207323417", price: 77.97, comparePrice: 94.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_f5f3cae2-1516-46f6-88cf-69855b80207f.jpg?v=1777207485" }] },
  { id: 10, title: "CuddleRide Cub", handle: "cuddleride-cub", isTopSeller: true, variants: [{ name: "Motorcycle", id: "51836002173209", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_9c578b9d-b363-4cb1-81f6-e2fc774e6fa4.jpg?v=1767806191" }, { name: "Octopus", id: "51836002042137", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_e357cc61-ad79-4272-a443-63853c4c05f7.png?v=1767806191" }, { name: "Police", id: "51836002074905", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_b5ae7860-8fce-49e8-93d3-c55c933a575e.png?v=1768852306" }, { name: "Ice Cream Scoops", id: "51836002107673", price: 75.00, comparePrice: 100.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_38fe2bda-6036-40ae-94e5-3c16cc8a6563.jpg?v=1768852306" }] },
  { id: 11, title: "Mamourse EasySeat", handle: "mamourse-easyseat", isTopSeller: true, variants: [{ name: "Grey", id: "52288229277977", price: 17.47, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_0bb1f4ee-14e8-449c-8cc7-bf745e7fe7a7.jpg?v=1777208806" }] },
  { id: 12, title: "Mom's Essentials Organizer", handle: "mamourse-moms-essentials-organizer", isTopSeller: true, variants: [{ name: "Grey", id: "50216409334041", price: 19.96, comparePrice: 29.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20231016-WA0092.jpg?v=1697553805" }] },
  { id: 13, title: "BearHug Kids U-Shaped Toothbrush", handle: "bearhug-kids-u-shaped-toothbrush", isTopSeller: false, variants: [{ name: "Small Blue", id: "46788720034073", price: 6.99, comparePrice: null, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/SAVE-20231021_192318.jpg?v=1697905553" }, { name: "Large Blue", id: "46788723376409", price: 6.99, comparePrice: null, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/SAVE-20231021_192318.jpg?v=1697905553" }, { name: "Small Pink", id: "46788720066841", price: 6.99, comparePrice: null, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/SAVE-20231021_192318.jpg?v=1697905553" }, { name: "Large Pink", id: "46788723409177", price: 6.99, comparePrice: null, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/SAVE-20231021_192318.jpg?v=1697905553" }] },
  { id: 14, title: "ComfortLift Baby Carrier", handle: "comfortlift-baby-carrier", isTopSeller: false, variants: [{ name: "Blue", id: "52303461810457", price: 34.97, comparePrice: 49.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/IMG-20231016-WA0088.jpg?v=1697475164" }] },
  { id: 15, title: "Cuddle Cub", handle: "cuddle-cub", isTopSeller: false, variants: [{ name: "Grey", id: "51217711563033", price: 15.00, comparePrice: 20.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_13ab440d-0fb7-40ac-94ba-ee97e7d4c10f.webp?v=1756297567" }] },
  { id: 16, title: "Stroller Hooks", handle: "stroller-hooks", isTopSeller: false, variants: [{ name: "Black", id: "52303112601881", price: 3.00, comparePrice: 5.00, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_612eb216-621d-4f70-bbcd-481be3b9ff64.png?v=1756297277" }] },
  { id: 18, title: "BearStack Meal Dispenser", handle: "bearstack-meal-dispenser", isTopSeller: false, variants: [{ name: "Pink", id: "50190336033049", price: 11.95, comparePrice: 19.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/0H3A7068.jpg?v=1777454648" }, { name: "Green", id: "50190336065817", price: 11.95, comparePrice: 19.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/0H3A7071.jpg?v=1777454649" }] },
  { id: 19, title: "The Smart Squeeze", handle: "the-smart-squeeze", isTopSeller: false, variants: [{ name: "Pink", id: "48044112019737", price: 8.99, comparePrice: 14.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse_spoons-1_40967f85-fb8c-4fc0-8618-a0b3b9c7386c.jpg?v=1777455122" }, { name: "Blue", id: "48044112052505", price: 8.99, comparePrice: 14.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/Mamourse_spoons-2_b9853e1b-e4f8-41ca-b989-fa3ad74d4af4.jpg?v=1777455122" }] },
  { id: 20, title: "SafeSnuggle Anti-Fall Pillow for Babies", handle: "safesnuggle-anti-fall-pillow-for-babies", isTopSeller: false, variants: [{ name: "Pink Soft Velvet", id: "47655345750297", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1735662857771.png?v=1735663295" }, { name: "Blue Soft Velvet", id: "47655345783065", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/1735662838602.png?v=1735663323" }, { name: "Pink Breathable", id: "50162284364057", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_04030449-c2d9-4ac9-b5b9-3988b5c5902d.png?v=1704385679" }, { name: "Blue Breathable", id: "50162284396825", price: 14.99, comparePrice: 24.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_b7d2f8a1-c5d4-4bb3-accb-e5595f822394.png?v=1704385679" }] },
  { id: 21, title: "TwinkleTyke Portable Baby Nightlight", handle: "twinkletyke-portable-baby-nightlight", isTopSeller: false, variants: [{ name: "Bunny", id: "47542584967449", price: 7.98, comparePrice: 11.97, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/image00004.jpg?v=1702069330" }, { name: "Bear", id: "47542585000217", price: 7.98, comparePrice: 11.97, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/image00005.jpg?v=1702069329" }] },
  { id: 22, title: "BearMunch Teething Mitt", handle: "bearmunch-teething-mitt", isTopSeller: false, variants: [{ name: "Brown", id: "47223127769369", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/brown.jpg?v=1759163809" }, { name: "Aqua", id: "47223127802137", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/green.jpg?v=1759163809" }, { name: "Pink", id: "47223127834905", price: 5.99, comparePrice: 9.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/pink_6daf18b5-8e40-407a-a6b3-b209172c98a0.jpg?v=1759163809" }] },
  { id: 26, title: "GlowRing™", handle: "glowring", isTopSeller: false, variants: [{ name: "Standard", id: "52390824083737", price: 1.47, comparePrice: 1.98, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_621528dd-c77d-4807-b3a6-506afecb6538.webp?v=1778527865" }] },
  { id: 27, title: "BedBuddy™", handle: "bedbuddy", isTopSeller: false, variants: [{ name: "Pink", id: "52376380539161", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }, { name: "Blue", id: "52376380571929", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }, { name: "Grey", id: "52376380604697", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }, { name: "White", id: "52380600008985", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }, { name: "Black", id: "52380600533273", price: 19.95, comparePrice: 27.49, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a8fce73e-48f0-4f2c-a8b1-6ee526caf01c.webp?v=1778528259" }] },
  { id: 28, title: "PrettyNest™", handle: "🌸-prettynest™", isTopSeller: false, isCustomizable: true, customImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_54c762e1-7a56-427f-8312-f374c7af71ed.png?v=1778787182", customPrice: 29.95 },
  { id: 29, title: "FirstBond™", handle: "firstbond™", isTopSeller: false, isCustomizable: true, customImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_79dc9286-52be-47f3-a1b4-ef267d6aac46.jpg?v=1778786905", customPrice: 16.95 },
  { id: 30, title: "Yummy Yelper Kit", handle: "yummy-yelper", isTopSeller: false, variants: [{ name: "Blue", id: "45074912575769", price: 6.99, comparePrice: 12.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/B_1.jpg?v=1778172233" }, { name: "Pink", id: "45074912674073", price: 6.99, comparePrice: 12.99, inStock: true, image: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/P_1.jpg?v=1778172235" }] },
  { id: 31, title: "🧸 BabyPeek™", handle: "babypeek™", isTopSeller: false, isDetailsOnly: true, customImage: "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/rn-image_picker_lib_temp_a81d0ce6-d7a7-49b3-a883-9e4f3cbe6c72.jpg?v=1790170016" }
];

// ============================================
// EXACT FILTER LISTS - UPDATED
// ============================================

// NEW BORN (0-3M) - UPDATED (removed KissableJoy and LittleCub)
const newbornFilter = [
  "CozyCub Baby Sleeping Bag",
  "Pandallow",
  "ComfortLift Baby Carrier",
  "Babybear Bag",
  "Butterfly Comfort Nursing Pillow",
  "Cuddle Pouch Hoodie",
  "Mom's Essentials Organizer",
  "TwinkleTyke Portable Baby Nightlight",
  "CubCloud Head Shaping Pillow",
  "BedBuddy™",
  "GlowRing™",
  "🧸 BabyPeek™",
];

// 3M+ - UPDATED (removed KissableJoy and LittleCub)
const threeMPlusFilter = [
  "CozyCub Baby Sleeping Bag",
  "Pandallow",
  "ComfortLift Baby Carrier",
  "Yummy Yelper Kit",
  "Butterfly Comfort Nursing Pillow",
  "Cuddle Pouch Hoodie",
  "Mom's Essentials Organizer",
  "Carrybear Bag",
  "TwinkleTyke Portable Baby Nightlight",
  "CubCloud Head Shaping Pillow",
  "Mamourse EasySeat",
  "BedBuddy™",
  "GlowRing™",
];

// 6M+ - UPDATED (removed KissableJoy and LittleCub)
const sixMPlusFilter = [
  "CozyCub Baby Sleeping Bag",
  "Pandallow",
  "ComfortLift Baby Carrier",
  "Yummy Yelper Kit",
  "Butterfly Comfort Nursing Pillow",
  "Cuddle Pouch Hoodie",
  "Mom's Essentials Organizer",
  "The Smart Squeeze",
  "Carrybear Bag",
  "SafeSnuggle Anti-Fall Pillow for Babies",
  "BearMunch Teething Mitt",
  "TwinkleTyke Portable Baby Nightlight",
  "CubCloud Head Shaping Pillow",
  "Mamourse EasySeat",
  "BedBuddy™",
  "GlowRing™",
];

// 9M+ - UPDATED (removed KissableJoy and LittleCub)
const nineMPlusFilter = [
  "Abjad",
  "Carrybear Bag",
  "ComfortLift Baby Carrier",
  "CozyCub Baby Sleeping Bag",
  "CubCloud Head Shaping Pillow",
  "Mamourse EasySeat",
  "Mom's Essentials Organizer",
  "Pandallow",
  "SafeSnuggle Anti-Fall Pillow for Babies",
  "The Smart Squeeze",
  "TwinkleTyke Portable Baby Nightlight",
  "Yummy Yelper Kit",
  "Zein Educational Toy",
  "BedBuddy™",
  "GlowRing™"
];

// TOP SELLERS - UPDATED (removed KissableJoy)
const topSellerFilter = [
  "CozyCub Baby Sleeping Bag",
  "Pandallow",
  "Babybear Bag",
  "Butterfly Comfort Nursing Pillow",
  "Cuddle Pouch Hoodie",
  "Mom's Essentials Organizer",
  "Carrybear Bag",
  "CubCloud Head Shaping Pillow",
  "Mamourse EasySeat",
  "CuddleRide Cub"
];

// ============================================
// FILTER FUNCTION - EXACT TITLE MATCHING
// ============================================

function getProductCategory(product) {
  // Check Top Sellers first (based on isTopSeller flag or title match)
  if (product.isTopSeller === true || topSellerFilter.includes(product.title)) {
    return "top-seller";
  }
  
  // Check each category
  if (newbornFilter.includes(product.title)) return "newborn";
  if (threeMPlusFilter.includes(product.title)) return "3m";
  if (sixMPlusFilter.includes(product.title)) return "6m";
  if (nineMPlusFilter.includes(product.title)) return "9m";
  
  return "all";
}

// ============================================
// HELPER FUNCTIONS
// ============================================

function getDefaultVariant(product) {
  if (product.isCustomizable || product.isDetailsOnly) return null;
  // First try to find an in-stock variant
  const inStockVariant = product.variants.find(v => v.inStock === true);
  if (inStockVariant) return inStockVariant;
  // If none in stock, return the first variant (which will show as sold out)
  return product.variants[0];
}

function getBasePrice(product) {
  if (product.isDetailsOnly) return product.livePrice || 0;
  if (product.isCustomizable) return product.customPrice || 14.95;
  const variant = getDefaultVariant(product);
  return variant?.price || 0;
}

function getSavePercentage(price, comparePrice) {
  if (!comparePrice || comparePrice <= price) return null;
  return Math.round(((comparePrice - price) / comparePrice) * 100);
}

// ============================================
// LIVE SHOPIFY SYNC - OVERWRITE STALE DATA
// ============================================

let isSyncingProducts = false;
let syncInterval = null;

function getShopifyImageSrc(imageData) {
  if (!imageData) return "";

  if (typeof imageData === "string") return imageData;

  if (imageData.src) return imageData.src;

  if (imageData.featured_image && imageData.featured_image.src) {
    return imageData.featured_image.src;
  }

  if (imageData.preview_image && imageData.preview_image.src) {
    return imageData.preview_image.src;
  }

  return "";
}

function getLiveVariantName(liveVariant, oldVariant = {}) {
  const optionParts = [
    liveVariant.option1,
    liveVariant.option2,
    liveVariant.option3
  ].filter(option => option && option !== "Default Title");

  if (optionParts.length > 0) {
    return optionParts.join(" / ");
  }

  if (liveVariant.title && liveVariant.title !== "Default Title") {
    return liveVariant.title;
  }

  return oldVariant.name || "Standard";
}

function getLiveVariantImage(liveVariant, productData, oldVariant = {}) {
  const liveVariantImage = getShopifyImageSrc(liveVariant.featured_image);
  if (liveVariantImage) return liveVariantImage;

  const oldImage = oldVariant.image;
  if (oldImage) return oldImage;

  const productFeaturedImage = getShopifyImageSrc(productData.featured_image);
  if (productFeaturedImage) return productFeaturedImage;

  if (Array.isArray(productData.images) && productData.images.length > 0) {
    return getShopifyImageSrc(productData.images[0]);
  }

  return "";
}

async function syncProductFromShopify(product) {
  if (product.isCustomizable && !product.isDetailsOnly) return false;
  if (!product.handle) return false;

  try {
    const response = await fetch(`/products/${product.handle}.js`, {
      method: "GET",
      headers: { "Accept": "application/json" }
    });

    if (!response.ok) {
      console.warn(`Failed to sync ${product.title}: HTTP ${response.status}`);
      return false;
    }

    const data = await response.json();

    if (product.isDetailsOnly) {
      product.livePrice = typeof data.price === "number" ? data.price / 100 : null;
      product.liveComparePrice =
        typeof data.compare_at_price === "number" && data.compare_at_price > data.price
          ? data.compare_at_price / 100
          : null;
      product.defaultImage =
        product.customImage ||
        getShopifyImageSrc(data.featured_image) ||
        (Array.isArray(data.images) && data.images.length > 0 ? getShopifyImageSrc(data.images[0]) : "");
      product.available = data.available === true;
      return true;
    }

    if (!data || !Array.isArray(data.variants) || data.variants.length === 0) {
      console.warn(`No live variants found for ${product.title}`);
      return false;
    }

    const oldVariants = Array.isArray(product.variants) ? product.variants : [];
    const oldVariantMap = new Map(
      oldVariants.map(variant => [String(variant.id), variant])
    );

    product.defaultImage =
      getShopifyImageSrc(data.featured_image) ||
      product.defaultImage ||
      oldVariants[0]?.image ||
      "";

    product.variants = data.variants.map(liveVariant => {
      const oldVariant = oldVariantMap.get(String(liveVariant.id)) || {};

      const price = liveVariant.price ? liveVariant.price / 100 : 0;
      const comparePrice =
        liveVariant.compare_at_price && liveVariant.compare_at_price > liveVariant.price
          ? liveVariant.compare_at_price / 100
          : null;

      return {
        name: getLiveVariantName(liveVariant, oldVariant),
        id: String(liveVariant.id),
        price: price,
        comparePrice: comparePrice,
        inStock: liveVariant.available === true,
        image: getLiveVariantImage(liveVariant, data, oldVariant),
        inventoryQuantity: liveVariant.inventory_quantity
      };
    });

    return true;
  } catch (error) {
    console.error(`Error syncing ${product.title}:`, error.message);
    return false;
  }
}

async function syncAllProductsFromShopify() {
  if (isSyncingProducts) {
    console.log('🔄 Sync already in progress, skipping...');
    return;
  }
  
  isSyncingProducts = true;
  console.log('🔄 Starting live Shopify sync for all products...');
  
  const syncPromises = [];
  for (const product of allProducts) {
    if (product.isDetailsOnly || (!product.isCustomizable && product.variants && product.variants.length > 0)) {
      syncPromises.push(syncProductFromShopify(product));
    }
  }
  
  const results = await Promise.allSettled(syncPromises);
  const successCount = results.filter(r => r.status === 'fulfilled' && r.value === true).length;
  console.log(`✅ Sync completed: ${successCount} products updated from Shopify`);
  
  isSyncingProducts = false;
  
  // Re-render the page with updated data
  renderProducts();
  // Re-attach filter listeners (they stay attached, but re-render is enough)
}

// ============================================
// ADD TO CART FUNCTION - PRESERVED EXACT BEHAVIOR
// ============================================

async function addToCartWithProperties(variantId, title, price, quantity, image, properties = {}) {
  try {
    const shopifyResponse = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ 
        id: Number(variantId), 
        quantity: quantity, 
        properties: properties 
      })
    });
    
    if (!shopifyResponse.ok) {
      const errorData = await shopifyResponse.json();
      throw new Error(errorData.description || 'Shopify cart add failed');
    }
    
    if (typeof window.addToCart === 'function') {
      window.addToCart({ 
        variant_id: variantId, 
        title: title, 
        price: price, 
        quantity: quantity, 
        image: image, 
        properties: properties 
      });
    }
    
    // Dispatch cart events for any listeners
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    document.dispatchEvent(new CustomEvent('cart:updated'));
    
    return true;
  } catch (error) {
    console.error('Add to cart error:', error);
    return false;
  }
}

// ============================================
// RENDER FUNCTIONS
// ============================================

let currentFilter = "all";
let currentSort = "default";

function filterProducts(products, filterType) {
  if (filterType === "all") return [...products];
  
  let filterList;
  switch(filterType) {
    case "newborn": filterList = newbornFilter; break;
    case "3m": filterList = threeMPlusFilter; break;
    case "6m": filterList = sixMPlusFilter; break;
    case "9m": filterList = nineMPlusFilter; break;
    case "top-seller": filterList = topSellerFilter; break;
    default: return [...products];
  }
  
  return products.filter(product => filterList.includes(product.title));
}

function sortProducts(products, sortType) {
  const sorted = [...products];
  switch(sortType) {
    case "name-asc": return sorted.sort((a, b) => a.title.localeCompare(b.title));
    case "name-desc": return sorted.sort((a, b) => b.title.localeCompare(a.title));
    case "price-asc": return sorted.sort((a, b) => getBasePrice(a) - getBasePrice(b));
    case "price-desc": return sorted.sort((a, b) => getBasePrice(b) - getBasePrice(a));
    default: return sorted;
  }
}

function renderProducts() {
  const grid = document.getElementById("shopAllGrid");
  if (!grid) return;
  
  let filteredProducts = filterProducts(allProducts, currentFilter);
  filteredProducts = sortProducts(filteredProducts, currentSort);
  
  grid.innerHTML = "";
  
  if (filteredProducts.length === 0) {
    grid.innerHTML = `<div class="no-results"><h3>No products found</h3><p>Try changing your filter</p></div>`;
    return;
  }
  
  filteredProducts.forEach(product => {
    if (product.isDetailsOnly) {
      renderDetailsOnlyProduct(product, grid);
    } else if (product.isCustomizable) {
      renderCustomizableProduct(product, grid);
    } else {
      renderNonCustomizableProduct(product, grid);
    }
  });
  
  attachEvents();
}

function renderDetailsOnlyProduct(product, grid) {
  const card = document.createElement("article");
  card.className = "product-card";
  card.setAttribute("data-product-handle", product.handle);
  card.setAttribute("data-details-only", "true");

  const productImage =
    product.customImage ||
    product.defaultImage ||
    "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/placeholder.jpg";
  const hasPrice = typeof product.livePrice === "number" && product.livePrice > 0;
  const hasCompare =
    hasPrice &&
    typeof product.liveComparePrice === "number" &&
    product.liveComparePrice > product.livePrice;

  card.innerHTML = `
    <div class="product-image-container">
      <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy">
      <div class="image-overlay">
        <a href="/products/${product.handle}" class="view-details-btn">
          <svg viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/></svg>
          <span>View Full Details</span>
        </a>
      </div>
    </div>
    <div class="product-info">
      <h3 class="product-title">${product.title}</h3>
      ${hasPrice ? `
        <div class="product-price">
          <span class="current-price">$${product.livePrice.toFixed(2)}</span>
          ${hasCompare ? `<span class="compare-price">$${product.liveComparePrice.toFixed(2)}</span>` : ""}
        </div>
      ` : ""}
      <a href="/products/${product.handle}" class="view-details-full-btn">
        <svg viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/></svg>
        <span>View Full Details</span>
      </a>
    </div>
  `;

  grid.appendChild(card);
}

function renderCustomizableProduct(product, grid) {
  const card = document.createElement("article");
  card.className = "product-card";
  card.setAttribute("data-product-handle", product.handle);
  card.setAttribute("data-customizable", "true");
  
  const productImage = product.customImage || "https://cdn.shopify.com/s/files/1/0713/0424/9625/files/placeholder.jpg";
  const productPrice = product.customPrice || 14.95;
  
  card.innerHTML = `
    <div class="product-image-container">
      <img src="${productImage}" alt="${product.title}" class="product-image" loading="lazy">
      <div class="image-overlay">
        <a href="/products/${product.handle}" class="view-details-btn"><svg viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/></svg><span>View Details</span></a>
      </div>
    </div>
    <div class="product-info">
      <h3 class="product-title">${product.title}</h3>
      <div class="product-price"><span class="current-price">$${productPrice.toFixed(2)}</span></div>
      <a href="/products/${product.handle}" class="view-details-full-btn"><svg viewBox="0 0 24 24"><path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/></svg><span>View Details</span></a>
    </div>
  `;
  grid.appendChild(card);
}

function renderNonCustomizableProduct(product, grid) {
  const firstVariant = getDefaultVariant(product);
  if (!firstVariant) return;

  const hasMultipleVariants = Array.isArray(product.variants) && product.variants.length > 1;
  const requiresVariantChoice = hasMultipleVariants;
  const displayImage = product.defaultImage || firstVariant.image;
  const savePercent = getSavePercentage(firstVariant.price, firstVariant.comparePrice);

  const card = document.createElement("article");
  card.className = "product-card";
  card.setAttribute("data-product-id", product.id);
  card.setAttribute("data-product-handle", product.handle);

  let dropdownOptions = "";

  if (requiresVariantChoice) {
    dropdownOptions += `
      <option value="" disabled selected data-placeholder="true">
        Choose your variant
      </option>
    `;
  }

  product.variants.forEach(variant => {
    const isSelected = !requiresVariantChoice && String(variant.id) === String(firstVariant.id);
    const soldOutClass = !variant.inStock ? "sold-out-option" : "";
    const optionText = variant.inStock ? variant.name : `${variant.name} (Sold Out)`;
    const variantImage = variant.image || displayImage || "";

    dropdownOptions += `
      <option
        value="${variant.id}"
        data-price="${variant.price}"
        data-compare="${variant.comparePrice || ""}"
        data-image="${variantImage}"
        data-instock="${variant.inStock}"
        data-variant-name="${variant.name}"
        class="${soldOutClass}"
        ${isSelected ? "selected" : ""}
      >
        ${optionText}
      </option>
    `;
  });

  const initialButtonDisabled = requiresVariantChoice || !firstVariant.inStock;
  const initialButtonText = requiresVariantChoice
    ? "Choose Variant"
    : firstVariant.inStock
      ? "Add to Cart"
      : "Sold Out";

  card.innerHTML = `
    <div class="product-image-container">
      <span class="sale-badge" style="${savePercent ? "" : "display:none;"}">
        ${savePercent ? `SAVE ${savePercent}%` : ""}
      </span>

      <img src="${displayImage}" alt="${product.title}" class="product-image" loading="lazy">

      <div class="image-overlay">
        <a href="/products/${product.handle}" class="view-details-btn">
          <svg viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5z"/>
          </svg>
          <span>View Details</span>
        </a>
      </div>

      <button
        class="image-cart-btn ${initialButtonDisabled ? "sold-out-mobile" : ""}"
        data-variant-id="${requiresVariantChoice ? "" : firstVariant.id}"
        data-title="${product.title}"
        data-variant-name="${requiresVariantChoice ? "" : firstVariant.name}"
        data-price="${requiresVariantChoice ? "" : firstVariant.price}"
        data-image="${requiresVariantChoice ? "" : displayImage}"
        ${initialButtonDisabled ? "disabled" : ""}
      >
        <svg viewBox="0 0 24 24">
          <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
      </button>
    </div>

    <div class="product-info">
      <h3 class="product-title">${product.title}</h3>

      <div class="variant-selector">
        <select class="variant-dropdown">${dropdownOptions}</select>
      </div>

      <div class="product-price">
        <span class="current-price">$${firstVariant.price.toFixed(2)}</span>
        <span class="compare-price" style="${firstVariant.comparePrice ? "" : "display:none;"}">
          ${firstVariant.comparePrice ? `$${firstVariant.comparePrice.toFixed(2)}` : ""}
        </span>
      </div>

      <button
        class="add-to-cart-btn ${initialButtonDisabled ? "sold-out" : ""}"
        data-variant-id="${requiresVariantChoice ? "" : firstVariant.id}"
        data-title="${product.title}"
        data-variant-name="${requiresVariantChoice ? "" : firstVariant.name}"
        data-price="${requiresVariantChoice ? "" : firstVariant.price}"
        data-image="${requiresVariantChoice ? "" : displayImage}"
        ${initialButtonDisabled ? "disabled" : ""}
      >
        <svg viewBox="0 0 24 24">
          <path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"/>
        </svg>
        <span>${initialButtonText}</span>
      </button>
    </div>
  `;

  grid.appendChild(card);
}

function attachEvents() {
  // Variant dropdown changes
  document.querySelectorAll(".product-card:not([data-customizable]) .variant-dropdown").forEach(dropdown => {
    dropdown.removeEventListener("change", dropdown._listener);

    dropdown._listener = function() {
      const card = this.closest(".product-card");
      const option = this.options[this.selectedIndex];

      const imageEl = card.querySelector(".product-image");
      const priceEl = card.querySelector(".current-price");
      const compareEl = card.querySelector(".compare-price");
      const desktopBtn = card.querySelector(".add-to-cart-btn");
      const mobileBtn = card.querySelector(".image-cart-btn");
      const saleBadge = card.querySelector(".sale-badge");

      if (!option || option.dataset.placeholder === "true" || !this.value) {
        [desktopBtn, mobileBtn].forEach(btn => {
          if (!btn) return;
          btn.disabled = true;
          btn.classList.add(btn.classList.contains("image-cart-btn") ? "sold-out-mobile" : "sold-out");
          btn.dataset.variantId = "";
          btn.dataset.price = "";
          btn.dataset.image = "";
          btn.dataset.variantName = "";

          const btnText = btn.querySelector("span");
          if (btnText) btnText.textContent = "Choose Variant";
        });
        return;
      }

      const variantPrice = parseFloat(option.dataset.price);
      const variantCompare = option.dataset.compare ? parseFloat(option.dataset.compare) : null;
      const variantImage = option.dataset.image || "";
      const variantId = this.value;
      const variantName = option.dataset.variantName || option.textContent.trim().replace(" (Sold Out)", "");
      const isInStock = option.dataset.instock === "true";

      if (variantImage && imageEl) {
        imageEl.src = variantImage;
      }

      if (priceEl && !Number.isNaN(variantPrice)) {
        priceEl.textContent = `$${variantPrice.toFixed(2)}`;
      }

      if (compareEl) {
        if (variantCompare && variantCompare > variantPrice) {
          compareEl.textContent = `$${variantCompare.toFixed(2)}`;
          compareEl.style.display = "inline";

          if (saleBadge) {
            const savePercent = Math.round(((variantCompare - variantPrice) / variantCompare) * 100);
            saleBadge.textContent = `SAVE ${savePercent}%`;
            saleBadge.style.display = "inline-flex";
          }
        } else {
          compareEl.textContent = "";
          compareEl.style.display = "none";

          if (saleBadge) {
            saleBadge.textContent = "";
            saleBadge.style.display = "none";
          }
        }
      }

      [desktopBtn, mobileBtn].forEach(btn => {
        if (!btn) return;

        btn.dataset.variantId = variantId;
        btn.dataset.price = variantPrice;
        btn.dataset.image = variantImage || imageEl?.src || "";
        btn.dataset.variantName = variantName;

        if (isInStock) {
          btn.disabled = false;
          btn.classList.remove("sold-out", "sold-out-mobile");

          const btnText = btn.querySelector("span");
          if (btnText) btnText.textContent = "Add to Cart";
        } else {
          btn.disabled = true;
          btn.classList.add(btn.classList.contains("image-cart-btn") ? "sold-out-mobile" : "sold-out");

          const btnText = btn.querySelector("span");
          if (btnText) btnText.textContent = "Sold Out";
        }
      });
    };

    dropdown.addEventListener("change", dropdown._listener);
  });

  // Add to cart buttons
  document.querySelectorAll(".product-card:not([data-customizable]) .add-to-cart-btn").forEach(btn => {
    btn.removeEventListener("click", btn._listener);

    btn._listener = async function(e) {
      e.stopPropagation();
      if (this.disabled || !this.dataset.variantId) return;

      const variantName = this.dataset.variantName || "";
      const properties = {};

      if (variantName && variantName !== "Standard" && variantName !== "Default Title") {
        properties["Variant"] = variantName;
      }

      await addToCartWithProperties(
        this.dataset.variantId,
        this.dataset.title,
        parseFloat(this.dataset.price),
        1,
        this.dataset.image,
        properties
      );
    };

    btn.addEventListener("click", btn._listener);
  });

  // Mobile cart buttons
  document.querySelectorAll(".product-card:not([data-customizable]) .image-cart-btn").forEach(btn => {
    btn.removeEventListener("click", btn._listener);

    btn._listener = async function(e) {
      e.stopPropagation();
      if (this.disabled || !this.dataset.variantId) return;

      const variantName = this.dataset.variantName || "";
      const properties = {};

      if (variantName && variantName !== "Standard" && variantName !== "Default Title") {
        properties["Variant"] = variantName;
      }

      await addToCartWithProperties(
        this.dataset.variantId,
        this.dataset.title,
        parseFloat(this.dataset.price),
        1,
        this.dataset.image,
        properties
      );
    };

    btn.addEventListener("click", btn._listener);
  });

  // Card click redirect
  document.querySelectorAll(".product-card").forEach(card => {
    card.removeEventListener("click", card._listener);

    card._listener = function(e) {
      if (
        e.target.tagName === "SELECT" ||
        e.target.tagName === "BUTTON" ||
        e.target.closest(".variant-selector") ||
        e.target.closest(".image-overlay") ||
        e.target.closest("a")
      ) {
        return;
      }

      const handle = this.dataset.productHandle;
      if (handle) window.location.href = `/products/${handle}`;
    };

    card.addEventListener("click", card._listener);
  });
}

function initFilters() {
  const filterButtons = document.querySelectorAll(".filter-btn");
  const sortSelect = document.getElementById("sort-select");
  
  filterButtons.forEach(btn => {
    btn.addEventListener("click", () => {
      filterButtons.forEach(b => b.classList.remove("active"));
      btn.classList.add("active");
      currentFilter = btn.dataset.filter;
      renderProducts();
    });
  });
  
  if (sortSelect) {
    sortSelect.addEventListener("change", () => {
      currentSort = sortSelect.value;
      renderProducts();
    });
  }
}

// ============================================
// INITIALIZATION
// ============================================

document.addEventListener("DOMContentLoaded", async function() {
  console.log("🛍️ Mamourse Shop All page initializing...");

  initFilters();
  currentFilter = "all";
  currentSort = "default";
  renderProducts();

  syncAllProductsFromShopify();

  if (syncInterval) clearInterval(syncInterval);
  syncInterval = setInterval(syncAllProductsFromShopify, 300000);
  console.log("⏰ Auto-resync set for every 5 minutes");
});